module.exports = __webpack_public_path__ + "img/wake.be5030ca.webp";